<template>
    <div class="text-right d-flex justify-end rota-clinic-item">
        <v-btn x-small
               class="mb-0 justify-space-between calendar-btn text-right"
               width="100%"
               v-if="data"
               :dark="isDark"
               :color="btnColor.bgc"
               :class="classAttr"
               @contextmenu.prevent="contextmenuHandler($event, data)"
               @click="btnClickHandler(data)">
            <v-tooltip top color="#000">
                <template v-slot:activator="{ on }">
                    <div v-if="processedData.holiday && isExistTypeOfHoliday(processedData.holiday.type)">
                      <v-icon class="mr-1" small v-on="on" color="#fff">${{convertTypeOfHoliday(processedData.holiday.type)}}</v-icon>
                    </div>
                    <div v-else>
                      <v-icon class="mr-1" small v-on="on" :color="isSelected ? '#fff' : btnColor.text">mdi-information</v-icon>
                    </div>
                </template>
                <div v-if="data" class="py-3">
                    <h4 class="text-uppercase pb-3">All records for today</h4>
                    <div v-for="(rotaData, index) in tooltipData" :key="rotaData.id" class="rota-item">
                        <b>
                            {{rotaData.title}}
                        </b>
                        <div v-for="roleInfo in rotaData.data" :key="roleInfo.id" class="caption">
                            {{roleInfo.designator ? `${roleInfo.designator.toUpperCase()}:` : ''}} {{roleInfo.text}}
                            <i v-if="roleInfo.text === 'Off' && processedData.holiday">* ({{processedData.holiday.type}} {{processedData.holiday.details}})</i>
                        </div>
                        <div v-if="index < tooltipData.length - 1" class="tooltip-container__border"/>
                    </div>
                    <div v-if="btnText.note">
                        <div class="tooltip-container__border"/>
                        <b>Note:</b>
                        <div>{{ btnText.note }}</div>
                    </div>
                </div>
            </v-tooltip>

            <div class="text-right calendar-btn_text" style="font-size: 10px" :style="`color: ${btnColor.text}`">
                <div>
                    <span class="calendar-btn_role">
                        <span style="font-size: 6px">{{btnText.designator}}</span>
                        <span style="font-size: 8px">
                            {{btnText.role}} {{btnText.status ? `/ ${btnText.status}` : ''}}
                        </span>
                    </span>
                </div>
                <div>
                    <span class="calendar-btn_clinic">
                         {{btnText.clinic}}
                    </span>
                </div>
            </div>
        </v-btn>
    </div>
</template>

<script>
    import { ROTA_STATUSES } from '@/common/constants'
    import ROTA_COLORS from '@/constatns/rotaColors'
    import { getRoleColor } from '@/common/functions'
    import { arrayTypesHoliday } from '@/constatns/typesOfHolidays'

    export default {
        name: 'CalendarActionBtn',
        props: ['data', 'rotaCLickHandler', 'week', 'tooltipInfo', 'isSelected'],
        data: () => ({
            designators: ['AM', 'PM']
        }),
        computed: {
            processedData () {
                const data = this.data
                data.clinicTitle = data.clinicTitle ? data.clinicTitle : 'No clinic'
                return data
            },
            tooltipData () {
                return this.tooltipInfo.reduce((info, item) => {
                    if (item.rotaDayData.length) {
                        const data = {
                            title: item.roleTitle,
                            id: item.id + item.roleTitle,
                            data: item.rotaDayData.map(item => {
                                const designator = item.designator
                                const { status, clinicTitle, surgeryTitle } = item

                                return {
                                    designator,
                                    status: status,
                                    text: status === ROTA_STATUSES.working ? `${clinicTitle}${surgeryTitle ? ` - ${surgeryTitle}` : ''}` : status
                                }
                            })
                        }
                        info.push(data)
                    }
                    return info
                }, [])
            },
            btnText () {
                const { designator, roleTitle, clinicTitle, status, note } = this.processedData
                return {
                    designator: designator.toUpperCase(),
                    role: roleTitle,
                    clinic: clinicTitle,
                    note,
                    status: status !== ROTA_STATUSES.working ? status : ''
                }
            },
            btnColor () {
                const { status } = this.data

                if (status === ROTA_STATUSES.off) {
                    return {
                        bgc: ROTA_COLORS.OFF,
                        text: '#000'
                    }
                } else if (status === ROTA_STATUSES.spare) {
                    return {
                        bgc: ROTA_COLORS.SPARE,
                        text: '#000'
                    }
                } else {
                    const color = getRoleColor(this.data.roleId)
                    if (color) {
                        return color
                    } else {
                        return ROTA_COLORS.DEFAULT
                    }
                }
            },
            isDark () {
                return this.data.status === ROTA_STATUSES.off
            },
            disabled () {
                return Date.checkIsPastDate(this.data.date)
            },
            classAttr () {
                let classStr = ''
                classStr += this.isSelected ? 'primary lighten-2' : ''
                if (this.disabled) {
                    classStr += ' btn-disabled'
                }

                if (this.data.note) classStr += ' btn-has-note'

                return classStr
            }
        },
        methods: {
            btnClickHandler (item) {
                if (this.disabled) {
                    return false
                }
                this.$emit('click:rota', item)
            },
            contextmenuHandler (event, item) {
                if (this.disabled) {
                    return false
                }
                event.rotaItem = item
                this.$emit('contextmenu', event)
            },
            isExistTypeOfHoliday (holiday) {
                return arrayTypesHoliday.some((item) => item.value === holiday.split(' ').join(''))
            },
            convertTypeOfHoliday (typeOfHoliday) {
                return typeOfHoliday.toLowerCase().split(' ').join('')
            }
        }
    }
</script>

<style lang="scss">
    .rota-clinic-item {
        margin-bottom: 5px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .rota-item {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .calendar-btn {
        &_text {
            text-transform: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            > div {
                position: relative;
                display: flex;
                align-items: center;
            }
        }
        &_role {
            display: inline-block;
            width: 0;
            opacity: 0;
            overflow: hidden;
            transition: all .3s;
        }
        &_clinic {
            display: inline-block;
            overflow: hidden;
            transition: all .3s;
        }
        &:not(.hover-disabled):hover {
            .calendar-btn_role {
                width: auto;
                opacity: 1;
            }
            .calendar-btn_clinic {
                width: 0;
                opacity: 0;
                overflow: hidden;
            }
        }
        &.btn-disabled {
            color: #8a8a8a !important;
        }
        &.btn-has-note:after {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            background: #6C9D39;
            border-radius: 50%;
            right: -5px;
            top: -5px;
            left: unset;
        }
    }
    .tooltip-container {
        &__border {
            border-bottom: 1px dashed #ffffff;
            border-top: none;
            border-left: none;
            border-right: none;
            margin: 15px 0;
            display: block;
        }
    }
</style>
